import React, { useContext, useState } from 'react';
import {
  Box,
  Grid,
  Select,
  Dialog,
  Button,
  Checkbox,
  MenuItem,
  TextField,
  Typography,
  IconButton,
  DialogTitle,
  FormControl,
  DialogContent,
  FormControlLabel
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { yupResolver } from '@hookform/resolvers';
import { useForm, Controller } from 'react-hook-form';
import { withStyles } from '@material-ui/core/styles';
import Autocomplete from '@material-ui/lab/Autocomplete';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import AutocompleteInput from 'components/CustomInputs/AutocompleteInput';
import { I18nContext } from 'translations';
import { modalMessage } from 'utils';
import { SIZE_CD } from 'utils/constants';
import { useStateValue } from 'context/store';
import { addStop } from 'context/booking/actions';
import Loading from 'components/Loading';
import { COUNTRY_CODE } from 'utils/constants';
import schema from './schema';
import styles from '../../Tables/styleTableFilters';

function ModalAddStop ({
  open,
  closeModal,
  cities,
  city,
  setCity,
  id,
  lang
}) {
  const { translate, langCode } = useContext(I18nContext);
  const [loading, setLoading] = useState(false);
  const [, dispatch] = useStateValue();
  const [address, setAddress] = useState();
  const [checkedDelivery, setCheckedDelivery] = useState(false);
  const { handleSubmit, control, errors, register, watch } = useForm({
    resolver: yupResolver(schema)
  });

  const messageOk = () => {
    setLoading(false);
    modalMessage(
      '',
      translate('claims.form.mssgOk'),
      'success',
      translate('accept'),
      true
    ).then(() => {
      closeModal();
    });
  };

  const submit = async values => {
    setLoading(true);
    const callback = await addStop(dispatch, id, {...values, address, counter_delivery: checkedDelivery }, lang)
    callback.status ? messageOk() : setLoading(false)
  }

  const handleSuggest = (info) => {
    setAddress(info);
 };

  return (
    <Dialog
      open={open}
      aria-describedby="alert-dialog-description"
      maxWidth="md"
      fullWidth
    >
      <DialogTitle disableTypography>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" style={{ color: '#7C3AED', fontWeight: 'bold' }}>
            {translate('app.express.addRoute')}
          </Typography>
          <IconButton onClick={closeModal} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      <DialogContent style={{ padding: '10px 40px 40px' }}>
        {loading && <Loading />}
        <form onSubmit={handleSubmit(submit)} noValidate>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ color: '#7C3AED', fontWeight: 'bold', marginBottom: 10 }}>
                {translate('prepakages.form.destinationAddress')}
              </Typography>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  {cities && cities.length > 0 && city && (
                    <Autocomplete
                      id="cities"
                      options={cities.length > 0 ? cities : [{ id: 'none', name: translate('app.express.noCities') }]}
                      autoHighlight
                      getOptionLabel={(option) => option.name || option}
                      renderInput={(params) => <TextField {...params} variant="outlined" size="small" placeholder="Ciudad" />}
                      value={city || cities[0]}
                      onChange={(event, newValue) => {
                        event.stopPropagation();
                        setCity && setCity(newValue);
                      }}
                      disabled={true}
                    />
                  )}
                </Grid>
                <Grid item sm={12} md={6}>
                  <AutocompleteInput
                    title={translate('app.operations.optimize.form.address')}
                    name="address"
                    address={address && address}
                    cityId={city._id}
                    pos={{ lat: city.location.lat, lon: city.location.lon }}
                    focus
                    handleChange={handleSuggest}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ color: '#7C3AED', fontWeight: 'bold', marginBottom: 10 }}>
                {translate('app.bulkLoad.failedStops.table.customer')}
              </Typography>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  <Controller
                    name="name"
                    control={control}
                    defaultValue=""
                    render={({ onChange, value }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder={translate('app.express.fullName')}
                        fullWidth
                        value={value}
                        onChange={onChange}
                      />
                    )}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <TextField
                    name="country_code"
                    inputRef={register()}
                    type="hidden"
                    defaultValue={COUNTRY_CODE[langCode][3]}
                  />
                  <TextField
                    name="phone"
                    defaultValue=""
                    variant="outlined"
                    inputRef={register()}
                    placeholder={translate('app.express.phone')}
                    fullWidth
                    size="small"
                    type="tel"
                    inputProps={{ maxLength: '15' }}
                    error={errors.phone && !!errors.phone}
                    helperText={errors.phone && translate(errors.phone.message)}
                  />     
                </Grid>
                <Grid item sm={12} md={6}>
                  <Controller
                    name="email"
                    control={control}
                    defaultValue=""
                    render={({ onChange, value }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder={translate('app.express.email')}
                        fullWidth
                        value={value}
                        onChange={onChange}
                        required
                        error={errors.email && !!errors.email}
                        helperText={errors.email && translate(errors.email.message)}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="subtitle2" style={{ color: '#7C3AED', fontWeight: 'bold', marginBottom: 10 }}>
                {translate('app.express.package')}
              </Typography>
              <Grid container spacing={2}>
                <Grid item sm={12} md={6}>
                  <Controller
                    name="indications"
                    control={control}
                    defaultValue=""
                    render={({ onChange, value }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder={translate('app.express.whatShouldTheDeliveryCourierDo')}
                        fullWidth
                        value={value}
                        onChange={onChange}
                        required
                        error={errors.indications && !!errors.indications}
                        helperText={errors.indications && translate(errors.indications.message)}
                      />
                    )}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <Controller
                    name="reference"
                    control={control}
                    defaultValue=""
                    render={({ onChange, value }) => (
                      <TextField
                        size="small"
                        variant="outlined"
                        placeholder={translate('app.express.orderNumber')}
                        fullWidth
                        value={value}
                        onChange={onChange}
                        required
                        error={errors.reference && !!errors.reference}
                        helperText={errors.reference && translate(errors.reference.message)}
                      />
                    )}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <Controller
                    name="size_cd"
                    control={control}
                    defaultValue={Object.keys(SIZE_CD)[0]}
                    render={({ onChange, value }) => (
                      <FormControl variant="outlined" fullWidth size="small">
                        <Select
                          value={value}
                          onChange={onChange}
                          displayEmpty
                        >
                          {Object.keys(SIZE_CD).map(key => (
                            <MenuItem key={key} value={key}>{translate(SIZE_CD[key])}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <Controller
                    name="declared_value"
                    control={control}
                    defaultValue=""
                    render={({ onChange, value }) => (
                      <TextField
                        placeholder={translate('app.express.declaredValue')}
                        variant="outlined"
                        inputProps={{ maxLength: '10' }}
                        size="small"
                        type="text"
                        value={value}
                        onChange={onChange}
                        fullWidth
                        required
                        error={errors.declared_value && !!errors.declared_value}
                        helperText={errors.declared_value && translate(errors.declared_value.message)}
                      />
                    )}
                  />
                </Grid>
                <Grid item sm={12} md={6}>
                  <FormControl style={{ marginBottom: 10 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          icon={<RadioButtonUncheckedIcon fontSize="small" />}
                          checkedIcon={<RadioButtonCheckedIcon fontSize="small" />}
                          name="counter_delivery"
                          inputRef={register()}
                          defaultChecked={false}
                          onChange={e => setCheckedDelivery(e.target.checked)}
                        />
                      }
                      label={translate('app.express.shouldTheDriverCollectMoney')}
                    />
                  </FormControl>
                </Grid>
                <Grid item sm={12} md={6}>
                  {checkedDelivery && (
                    <TextField
                      name="collected_value"
                      defaultValue=""
                      variant="outlined"
                      inputRef={register()}
                      placeholder={translate('app.express.collectedValue')}
                      fullWidth
                      size="small"
                      type="tel"
                      inputProps={{ maxLength: '15' }}
                      error={errors.collected_value && !!errors.collected_value}
                      helperText={errors.collected_value && translate(errors.collected_value.message)}
                    />
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} className="text-right">
              <Button
                variant="contained"
                type="submit"
                color="primary"
                disabled={(address === undefined && address?.lat === undefined) || (watch('counter_delivery') && watch('collected_value') === '')}
                style={{ borderRadius: '25px', textTransform: 'none', padding: '8px 30px' }}
              >
                {translate('app.express.addStop')}
              </Button>
            </Grid>
          </Grid>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default withStyles(styles)(ModalAddStop);
